<template>
    <PublicTemplate>
        <section v-if="postData" class="Hero__HeroPost-x4lyh1-0 besnLg fade_in gDnLTL">
            <div class="container"><a class="back_to_projects" href="/blog"><svg version="1.1"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <g>
                            <g>
                                <path
                                    d="M492,236H68.442l70.164-69.824c7.829-7.792,7.859-20.455,0.067-28.284c-7.792-7.83-20.456-7.859-28.285-0.068 l-104.504,104c-0.007,0.006-0.012,0.013-0.018,0.019c-7.809,7.792-7.834,20.496-0.002,28.314c0.007,0.006,0.012,0.013,0.018,0.019 l104.504,104c7.828,7.79,20.492,7.763,28.285-0.068c7.792-7.829,7.762-20.492-0.067-28.284L68.442,276H492 c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z">
                                </path>
                            </g>
                        </g>
                    </svg>Back to all blogs</a>
                <h4><a>
                        {{ postData.parent.title }}
                    </a></h4>
                <h1>{{ postData.title }}</h1>
            </div>
        </section>
        <section v-if="postData" class="slug__PostContent-sc-1s4rcl5-0 jRuwXw">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="container_small" v-html="postData.content">
                </div>
            </div>
        </section>
        <div v-html="postStyle"></div>
    </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
const axios = require('axios').default;
export default {
    data() {
        return {
            list: [],
            postData: null
        }
    },
    name: 'PostView',
    async mounted() {
        window.scrollTo(0, 0);
        try {
            let link = this.link;
            if (link.substring(link.length - 1) == "/") {
                link = link.substring(0, link.length - 1);
            }
            let res = await axios.get("/api/" + link + ".json");
            if (res) {
                this.postData = res.data;
            }
        } catch {
            console;
        }
    },
    computed: {
        link() {
            return this.$route.path;
        },
        postStyle() {
            let bg = (this.postData && this.postData.background) ? this.postData.background : "";
            return `
            <style>
            .gDnLTL {
    width: 100%;
    background-image: url('${bg}');
    background-size: cover;
    background-position: center;
    height: 52vh;
    min-height: 470px;
    background-color: var(--bg_black);
    position: relative;
    opacity: 0;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}
    </style>
    `
        }
    },
    components: {
        PublicTemplate
    }
}
</script>

<style lang="less">
.iBTqZx {
    margin-top: 50px;
    text-align: center;
    display: grid;
    place-items: center;
}

/*!sc*/
.iBTqZx a {
    font-size: 0.5em;
    -webkit-letter-spacing: 1.4px;
    -moz-letter-spacing: 1.4px;
    -ms-letter-spacing: 1.4px;
    letter-spacing: 1.4px;
    color: #050505;
    -webkit-text-decoration: none;
    text-decoration: none;
    padding: 15px 60px;
    border: 1px solid #0b0b0b;
    border-radius: 4px;
    text-transform: capitalize;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    display: inline;
    text-transform: uppercase;
}

/*!sc*/
@media (max-width:1024px) {
    .iBTqZx a {
        font-size: 0.7em;
        padding: 12px 50px;
    }
}

/*!sc*/
.iBTqZx a:hover {
    background: var(--brand_black);
    color: #fff;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
data-styled.g4[id="SiteButton__LinkWrapper-o4bfn9-0"] {
    content: "iBTqZx,"
}

/*!sc*/
.hWBHX {
    background: var(--brand_black);
    opacity: 0;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper {
        padding-top: 50px;
        padding-bottom: 15px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-column-gap: 90px;
    column-gap: 90px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 55px;
    color: white;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
        margin-bottom: 30px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 34px;
    margin-right: 15px;
    fill: white;
    padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
        height: 26px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
    margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
    color: #fff;
    text-align: left;
    margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    display: block;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
        padding-bottom: 60px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: left;
    display: block;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
        place-items: center;
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
    color: white;
    border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
    color: var(--brand_black);
    background-color: white;
    -webkit-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    padding-top: 75%;
    display: block;
    -webkit-text-decoration: none;
    text-decoration: none;
    overflow: hidden;
    position: relative;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
        display: none;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
    height: 100%;
    display: block;
    position: absolute;
    object-fit: cover;
    object-position: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
    content: "hWBHX,"
}

/*!sc*/
.iuswnX {
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    gap: 10px;
}

/*!sc*/
.iuswnX li {
    list-style-type: none;
}

/*!sc*/
.iuswnX li a svg {
    width: 20px;
    height: 20px;
    display: block;
    fill: var(--brand_black);
}

/*!sc*/
data-styled.g98[id="SocialShare__SocialShareList-sc-12f89o4-0"] {
    content: "iuswnX,"
}

/*!sc*/


/*!sc*/
.gDnLTL.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
    .gDnLTL {
        height: 280px;
    }
}

/*!sc*/
.gDnLTL:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.gDnLTL .back_to_projects {
    position: absolute;
    color: white;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-size: 13px;
    line-height: 1;
    border: 1px solid white;
    padding: 12px 40px;
    border-radius: 3px;
    top: -50px;
    left: 0px;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    z-index: 3;
}

/*!sc*/
.gDnLTL .back_to_projects:hover {
    background-color: white;
    color: var(--brand_black);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.gDnLTL .back_to_projects:hover svg {
    fill: var(--brand_black);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.gDnLTL .back_to_projects svg {
    position: absolute;
    height: 17px;
    left: 10px;
    top: 10px;
    fill: white;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.gDnLTL .container {
    background-color: white;
    position: absolute;
    bottom: -90px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    padding: 80px 100px;
    max-width: 1150px;
    width: 100%;
    padding: 60px 50px;
    z-index: 2;
}

/*!sc*/
@media (max-width:1024px) {
    .gDnLTL .container {
        padding: 20px 15px;
        bottom: 15px;
        width: calc(100vw - 30px);
    }
}

/*!sc*/
.gDnLTL .container h1 {
    font-size: 1.35em;
    font-weight: 300;
    text-transform: uppercase;
    -webkit-letter-spacing: 2.66px;
    -moz-letter-spacing: 2.66px;
    -ms-letter-spacing: 2.66px;
    letter-spacing: 2.66px;
    max-width: 80%;
}

/*!sc*/
@media (max-width:1024px) {
    .gDnLTL .container h1 {
        max-width: 100%;
        font-size: 1em;
    }
}

/*!sc*/
.gDnLTL .container h4 {
    font-size: 0.5em;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
    color: var(--bg_black);
    font-weight: 300;
    text-transform: uppercase;
    margin-bottom: 20px;
}

/*!sc*/
.gDnLTL .container h4 a {
    -webkit-text-decoration: none;
    text-decoration: none;
    color: var(--bg_black);
}

/*!sc*/
.gDnLTL .container h4 span {
    margin: 0 10px;
}

/*!sc*/
@media (max-width:1024px) {
    .gDnLTL .container h4 span {
        margin: 0 3px;
    }
}

/*!sc*/
.gDnLTL .container .social_share {
    position: absolute;
    right: 80px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

/*!sc*/
@media (max-width:1024px) {
    .gDnLTL .container .social_share {
        display: none;
    }
}

/*!sc*/
data-styled.g99[id="Hero__HeroPost-x4lyh1-0"] {
    content: "gDnLTL,"
}

/*!sc*/
.jRuwXw {
    background-color: #f7f5f4;
    padding-top: 110px;
    min-height: 300px;
    padding-bottom: 80px;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .jRuwXw {
        padding-top: 15px;
        padding-bottom: 60px;
    }
}

/*!sc*/
.jRuwXw .container_small {
    padding: 50px;
    max-width: 870px;
    width: 100%;
    margin: 0 auto;
}

/*!sc*/
@media (max-width:1024px) {
    .jRuwXw .container_small {
        padding: 15px;
    }
}

/*!sc*/
.jRuwXw .container_small .content p {
    text-align: justify;
    -webkit-letter-spacing: 0.5px;
    -moz-letter-spacing: 0.5px;
    -ms-letter-spacing: 0.5px;
    letter-spacing: 0.5px;
    margin-bottom: 15px;
}

/*!sc*/
@media (max-width:1024px) {
    .jRuwXw .container_small .content p {
        font-size: 0.9em;
    }
}

/*!sc*/
.jRuwXw .container_small .content img {
    max-width: 100%;
    margin: 10px 0;
}

/*!sc*/
.jRuwXw .container_small .content ul {
    list-style-type: none;
}

/*!sc*/
.jRuwXw .container_small .content ul li {
    text-align: left;
}

/*!sc*/
.jRuwXw .share_socials_mobile {
    display: none;
    padding-top: 40px;
}

/*!sc*/
@media (max-width:1024px) {
    .jRuwXw .share_socials_mobile {
        display: block;
    }
}

/*!sc*/
.jRuwXw .share_socials_mobile .social_share {
    text-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 120px;
    overflow: auto;
    margin: 0 auto;
}

/*!sc*/
.jRuwXw .share_socials_mobile .social_share li {
    display: block;
    float: left;
    margin: 0 5px;
}

/*!sc*/
.jRuwXw .share_socials_mobile .social_share li a {
    display: block;
}

/*!sc*/
.jRuwXw .link_wrapper {
    margin-top: 0;
}

/*!sc*/
@media (max-width:1024px) {
    .jRuwXw .link_wrapper {
        margin-top: 60px;
    }
}

/*!sc*/
data-styled.g101[id="slug__PostContent-sc-1s4rcl5-0"] {
    content: "jRuwXw,"
}

/*!sc*/
</style>